/* ==========================================================================
   LOVY — Custom Homepage scripts
   Loaded by layout/lovy-home.liquid
   ----------------------------------------------------------------------------
   1. Star rating renderer      [data-stars]
   2. Marquee builder           #marquee-1 / #marquee-2
   3. Announcement countdown    .fk-countdown
   4. FAQ accordion             .faq__item
   5. Product tabs              .tabs .tab  ->  .best__panel
   6. Sliders                   #products-slider / #reviews-slider
   7. Mobile menu toggle        [data-menu-toggle]
   ========================================================================== */
(function () {
  'use strict';

  /* ---------- 1. STAR RATINGS --------------------------------------------- */
  function stars() {
    var STAR = 'M12 2l2.9 6.3 6.9.7-5.1 4.6 1.4 6.8L12 17.8 5.9 20.4l1.4-6.8L2.2 9l6.9-.7z';
    var FULL = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="' + STAR + '"></path></svg>';
    var HALF = '<svg viewBox="0 0 24 24"><defs><linearGradient id="lovy-half"><stop offset="50%" stop-color="#2d2f7c"></stop><stop offset="50%" stop-color="#d9d9e0"></stop></linearGradient></defs><path fill="url(#lovy-half)" d="' + STAR + '"></path></svg>';
    var EMPTY = '<svg viewBox="0 0 24 24" fill="#d9d9e0"><path d="' + STAR + '"></path></svg>';

    document.querySelectorAll('[data-stars]').forEach(function (el) {
      var v = parseFloat(el.getAttribute('data-stars')) || 0;
      var html = '';
      for (var i = 1; i <= 5; i++) {
        html += v >= i ? FULL : (v >= i - 0.5 ? HALF : EMPTY);
      }
      el.innerHTML = html;
    });
  }

  /* ---------- 2. MARQUEE --------------------------------------------------- */
  function marquee() {
    var ICONS = {
      off:  '<svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="12" r="9"></circle><path d="M8.5 15.5l7-7"></path><circle cx="9" cy="9" r="1.2" fill="#fff"></circle><circle cx="15" cy="15" r="1.2" fill="#fff"></circle></svg>',
      ship: '<svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 4h13v11H1z"></path><path d="M14 8h4l3 3v4h-7z"></path><circle cx="6" cy="18" r="1.8"></circle><circle cx="17.5" cy="18" r="1.8"></circle></svg>',
      sale: '<svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="5" width="18" height="16" rx="2"></rect><path d="M3 9h18M8 3v4M16 3v4"></path></svg>'
    };
    var ITEMS = [['off', 'Up To 62% Off'], ['ship', 'Free Shipping'], ['sale', 'Sale Ends Today']];

    function rowHTML() {
      var s = '';
      for (var r = 0; r < 5; r++) {
        ITEMS.forEach(function (it) {
          s += '<div class="marquee__item">' + ICONS[it[0]] + '<span>' + it[1] + '</span></div>';
        });
      }
      return s;
    }

    var track = '<div class="marquee__track">' +
                  '<div class="marquee__row">' + rowHTML() + '</div>' +
                  '<div class="marquee__row" aria-hidden="true">' + rowHTML() + '</div>' +
                '</div>';

    ['marquee-1', 'marquee-2'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) el.innerHTML = track;
    });
  }

  /* ---------- 3. COUNTDOWN ------------------------------------------------- */
  function countdown() {
    document.querySelectorAll('.fk-countdown').forEach(function (cd) {
      var elD = cd.querySelector('[data-js="countdown-day"]');
      var elH = cd.querySelector('[data-js="countdown-hour"]');
      var elM = cd.querySelector('[data-js="countdown-minute"]');
      var elS = cd.querySelector('[data-js="countdown-second"]');

      function attr(n) { return parseInt(cd.getAttribute(n) || '0', 10) || 0; }
      function pad(n) { return String(n).padStart(2, '0'); }

      var total = attr('days') * 86400 + attr('hours') * 3600 + attr('minutes') * 60 + attr('seconds');
      if (total <= 0) total = 20 * 3600;
      var end = Date.now() + total * 1000;

      function render() {
        var t = Math.round((end - Date.now()) / 1000);
        if (t <= 0) { end = Date.now() + total * 1000; t = total; } /* loop */
        if (elD) elD.textContent = pad(Math.floor(t / 86400));
        if (elH) elH.textContent = pad(Math.floor(t % 86400 / 3600));
        if (elM) elM.textContent = pad(Math.floor(t % 3600 / 60));
        if (elS) elS.textContent = pad(t % 60);
      }

      render();
      setInterval(render, 1000);
    });
  }

  /* ---------- 4. FAQ ACCORDION -------------------------------------------- */
  function faq() {
    var items = document.querySelectorAll('.faq__item');
    items.forEach(function (item) {
      var q = item.querySelector('.faq__q');
      var a = item.querySelector('.faq__a');
      if (!q || !a) return;

      q.addEventListener('click', function () {
        var open = item.classList.contains('is-open');
        items.forEach(function (o) {
          o.classList.remove('is-open');
          var oa = o.querySelector('.faq__a');
          if (oa) oa.style.maxHeight = null;
        });
        if (!open) {
          item.classList.add('is-open');
          a.style.maxHeight = a.scrollHeight + 'px';
        }
      });
    });
  }

  /* ---------- 5. TABS ------------------------------------------------------ */
  function tabs() {
    var tabEls = document.querySelectorAll('.tabs .tab');
    var panels = document.querySelectorAll('.best__panel');

    tabEls.forEach(function (t) {
      t.addEventListener('click', function () {
        tabEls.forEach(function (x) {
          x.classList.remove('is-active');
          x.setAttribute('aria-selected', 'false');
        });
        t.classList.add('is-active');
        t.setAttribute('aria-selected', 'true');

        var pid = t.getAttribute('data-panel');
        panels.forEach(function (p) { p.classList.toggle('is-active', p.id === pid); });
      });
    });
  }

  /* ---------- 6. SLIDERS --------------------------------------------------- */
  function sliders() {
    function setup(sliderId, progressId) {
      var slider = document.getElementById(sliderId);
      var progress = document.getElementById(progressId);
      if (!slider) return;

      function step() {
        var c = slider.querySelector('*');
        return c ? c.getBoundingClientRect().width + 24 : 300;
      }

      function update() {
        if (!progress) return;
        var max = slider.scrollWidth - slider.clientWidth;
        var ratio = max > 0 ? slider.scrollLeft / max : 0;
        var visible = slider.clientWidth / slider.scrollWidth;
        var barW = Math.max(visible * 100, 14);
        progress.style.width = barW + '%';
        progress.style.left = (ratio * (100 - barW)) + '%';
      }

      slider.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);

      var nav = document.querySelector('[data-slider="' + sliderId + '"]');
      if (nav) {
        nav.querySelectorAll('button').forEach(function (b) {
          b.addEventListener('click', function () {
            slider.scrollBy({ left: (b.dataset.dir === 'next' ? 1 : -1) * step(), behavior: 'smooth' });
          });
        });
      }

      update();
    }

    setup('products-slider', 'products-progress');
    setup('reviews-slider', 'reviews-progress');
  }

  /* ---------- 7. MOBILE MENU ---------------------------------------------- */
  function mobileMenu() {
    var btn = document.querySelector('[data-menu-toggle]');
    var menu = document.getElementById('lovy-mobile-menu');
    if (!btn || !menu) return;

    btn.addEventListener('click', function () {
      var open = !menu.hasAttribute('hidden');
      if (open) { menu.setAttribute('hidden', ''); } else { menu.removeAttribute('hidden'); }
      btn.setAttribute('aria-expanded', String(!open));
    });
  }

  /* ---------- BOOT --------------------------------------------------------- */
  function init() {
    stars();
    marquee();
    countdown();
    faq();
    tabs();
    sliders();
    mobileMenu();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
